import { ActiveMinutes } from '@dialogue/services'
import { Platform } from 'react-native'

type ValueOf<T> = T[keyof T]
type TrackerName = ValueOf<typeof ActiveMinutes.Types.TrackerName>
type ActivityType = ValueOf<typeof ActiveMinutes.Types.ActivityType>

type TrackerList = TrackerName[]
type SupportedTrackerActivitiesMap = Partial<Record<TrackerName, ActivityType[]>>
type PlatformSupportedTrackersMap = {
  ios: TrackerList
  default: TrackerList
  android: TrackerList
}

export const SDK_TRACKERS: TrackerList = [
  ActiveMinutes.Types.TrackerName.AppleHealth,
  ActiveMinutes.Types.TrackerName.HealthConnect,
]

const defaultSupportedTrackers: TrackerList = [
  ActiveMinutes.Types.TrackerName.Garmin,
  ActiveMinutes.Types.TrackerName.Strava,
]

const supportedTrackersByPlatform: PlatformSupportedTrackersMap = {
  ios: [ActiveMinutes.Types.TrackerName.AppleHealth, ...defaultSupportedTrackers],
  default: defaultSupportedTrackers,
  android: [ActiveMinutes.Types.TrackerName.HealthConnect, ...defaultSupportedTrackers],
}

export const supportedTrackers = Platform.select<TrackerList>(supportedTrackersByPlatform)

export const comingSoonTrackers: TrackerList = [
  ActiveMinutes.Types.TrackerName.SamsungHealth,
  ActiveMinutes.Types.TrackerName.Withings,
]

// Google fit will be supported just until the end of 2026.
export const deprecatedTrackers: TrackerList = [
  ActiveMinutes.Types.TrackerName.GoogleFit,
  ActiveMinutes.Types.TrackerName.Fitbit,
]

export const supportedTrackerActivities: SupportedTrackerActivitiesMap = {
  [ActiveMinutes.Types.TrackerName.AppleHealth]: [
    ActiveMinutes.Types.ActivityType.STEPS,
    ActiveMinutes.Types.ActivityType.RUNNING,
    ActiveMinutes.Types.ActivityType.CYCLING,
    ActiveMinutes.Types.ActivityType.SWIMMING,
  ],
  [ActiveMinutes.Types.TrackerName.HealthConnect]: [
    ActiveMinutes.Types.ActivityType.STEPS,
    ActiveMinutes.Types.ActivityType.RUNNING,
    ActiveMinutes.Types.ActivityType.CYCLING,
    ActiveMinutes.Types.ActivityType.SWIMMING,
  ],
  [ActiveMinutes.Types.TrackerName.GoogleFit]: [
    ActiveMinutes.Types.ActivityType.STEPS,
    ActiveMinutes.Types.ActivityType.RUNNING,
    ActiveMinutes.Types.ActivityType.CYCLING,
    ActiveMinutes.Types.ActivityType.SWIMMING,
  ],
  [ActiveMinutes.Types.TrackerName.Fitbit]: [
    ActiveMinutes.Types.ActivityType.STEPS,
    ActiveMinutes.Types.ActivityType.RUNNING,
    ActiveMinutes.Types.ActivityType.CYCLING,
    ActiveMinutes.Types.ActivityType.SWIMMING,
  ],
  [ActiveMinutes.Types.TrackerName.Garmin]: [
    ActiveMinutes.Types.ActivityType.STEPS,
    ActiveMinutes.Types.ActivityType.RUNNING,
    ActiveMinutes.Types.ActivityType.CYCLING,
    ActiveMinutes.Types.ActivityType.SWIMMING,
  ],
  [ActiveMinutes.Types.TrackerName.Strava]: [
    ActiveMinutes.Types.ActivityType.RUNNING,
    ActiveMinutes.Types.ActivityType.CYCLING,
    ActiveMinutes.Types.ActivityType.SWIMMING,
  ],
}
